import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useUserInfor } from "../../../../../../../Context/User";
import { AtualizarConfigGeralController } from "../../../../../../../Controllers/Geral/GestaoDeCadastros/ConfigGeral/ConfigGeralController";
import {
    IConfigGeral_Cobranca,
    IConfigGeral_URA,
} from "../../../../../../../Interfaces/Geral/GestaoDeCadastro/ConfigGeral/ConfigGeralInterface";
import { replaceClass } from "../../../../../../../Tools/Classtools";
import ConfigGeral, { IConfigMeta } from "../ConfigGeral";
import SelectCategoriaAtendimento from "../../../../../../CardsPages/Forms/SelectCategoriaAtendimento";
import OrSpinner from "../../../../../../Utils/OrSpinner";
import { IConfigGeralModulos } from "../../../../../../../Interfaces/Geral/ConfigGeral/ConfigGeral";
import useAsyncEffect from "../../../../../../../hooks/useAsyncEffect";
import { GetConfigModuloController } from "../../../../../../../Controllers/Geral/ConfigGeral/ConfigGeralController";

interface ICobrancaConfig {
    lstConfigModulo: IConfigGeralModulos[] | undefined;
    AtualizarConfigModulo: (requestBody: IConfigGeralModulos) => Promise<any>;
    ListConfigModulo: (...args: any[]) => Promise<IConfigGeralModulos[]>;
}

export default function CobrancaConfig(props: ICobrancaConfig) {
    const { Config, updateConfig } = useUserInfor();
    const config = Config.ConfigCobrancaDTO;
    let configUra = Config.ConfigsUraDTO;
    const [findCategoria, setFindCategoria] = useState<
        IConfigGeral_URA | undefined
    >();
    const { register, handleSubmit, formState, watch, control } = useForm();
    const formWatcher = watch();
    const [loading, setLoading] = useState(true);

    const idModuloCobranca = props.lstConfigModulo?.find(
        (lst) => lst.ID_MODULO === 3
    );

    const { value: getConfigModulo } = useAsyncEffect(async () => {
        if (idModuloCobranca) {
            return GetConfigModuloController(idModuloCobranca.ID_MODULO);
        }
    }, [idModuloCobranca]);

    const showSubmitButton = useCallback(
        (formWatcher: any, config: IConfigGeral_Cobranca) => {
            const DIAS_MINIMO_GERAR_BOLETO = Number.parseInt(
                formWatcher.DIAS_MINIMO_GERAR_BOLETO
            );
            const DIAS_PROMESSA_PAGAMENTO = Number.parseInt(
                formWatcher.DIAS_PROMESSA_PAGAMENTO
            );
            const findConfigUra = configUra?.find((config) => {
                return (
                    config.ID_CATEGORIA_ATENDIMENTO ===
                    formWatcher.ID_CATEGORIA_ATENDIMENTO //valida se tem id dentro da categoria
                );
            });

            if (
                DIAS_MINIMO_GERAR_BOLETO !==
                    config.NR_DIAS_MINIMO_GERAR_BOLETO_PARCELA_VENCIDA ||
                DIAS_PROMESSA_PAGAMENTO !== config.NR_DIAS_PROMESSA_PAGAMENTO ||
                // eslint-disable-next-line eqeqeq
                findConfigUra?.ID_CATEGORIA_ATENDIMENTO !=
                    formWatcher.ID_CATEGORIA_ATENDIMENTO
            )
                replaceClass(
                    "cobranca_config_form_submit_button",
                    "d-none",
                    "d-flex"
                );
            else
                replaceClass(
                    "cobranca_config_form_submit_button",
                    "d-flex",
                    "d-none"
                );
        },
        [configUra]
    );
    const handleInputChange = () => {
        showSubmitButton(formWatcher, config);
    };

    function handleDiasFormSubmit(formData: any) {
        config.NR_DIAS_MINIMO_GERAR_BOLETO_PARCELA_VENCIDA =
            formData.DIAS_MINIMO_GERAR_BOLETO
                ? formData.DIAS_MINIMO_GERAR_BOLETO
                : 0;
        config.NR_DIAS_PROMESSA_PAGAMENTO = formData.DIAS_PROMESSA_PAGAMENTO
            ? formData.DIAS_PROMESSA_PAGAMENTO
            : 0;
        configUra = formData.ID_CATEGORIA_ATENDIMENTO
            ? [
                  {
                      ID_CATEGORIA_ATENDIMENTO:
                          formData.ID_CATEGORIA_ATENDIMENTO,
                      ID_TIPO_CASO: 3,
                  },
              ]
            : configUra;
        update();
    }

    function update() {
        AtualizarConfigGeralController({
            ...Config,
            ConfigCobrancaDTO: {
                ...config,
            },
            ConfigsUraDTO: configUra,
        }).then(() => {
            updateConfig();
        });
    }

    //faz a atualização do botão sempre que há uma atualização no config
    useEffect(() => {
        if (
            (formWatcher.DIAS_MINIMO_GERAR_BOLETO &&
                formWatcher.DIAS_PROMESSA_PAGAMENTO) ||
            formWatcher.ID_CATEGORIA_ATENDIMENTO
        ) {
            showSubmitButton(formWatcher, Config.ConfigCobrancaDTO);
        }
    }, [Config, formWatcher, showSubmitButton]);

    useEffect(() => {
        if (loading) {
            const findCategoriaAtendimento = configUra?.find((config) => {
                return config.ID_TIPO_CASO === 3;
            });
            setFindCategoria(findCategoriaAtendimento);
            setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [configUra]);

    return (
        <ConfigGeral.Container configObj={config} update={update}>
            <OrSpinner loading={loading} loadingColor="primary">
                <div className="row">
                    <div className="col-12 mb-4">
                        <ConfigGeral.Flags configMeta={configMeta} />

                        <h4>Abrir novo atendimento</h4>
                        <div className="d-flex flex-column mb-3">
                            <label className="col-12 col-form-label px-0">
                                Abrir novo atendimento ao receber resposta do
                                cliente no email de finalização do caso.
                            </label>
                            <div className="col-6">
                                <span className="switch switch-outline switch-icon switch-success">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={
                                                getConfigModulo
                                                    ?.ConfigModuloCampo
                                                    .FL_CRIAR_ATEND_RESPOSTA_EMAIL
                                            }
                                            onChange={(e) => {
                                                props
                                                    .AtualizarConfigModulo({
                                                        ConfigModuloCampo: {
                                                            ...getConfigModulo?.ConfigModuloCampo,
                                                            FL_CRIAR_ATEND_RESPOSTA_EMAIL:
                                                                Boolean(
                                                                    e.target
                                                                        .checked
                                                                ),
                                                        },
                                                        ID_MODULO:
                                                            getConfigModulo?.ID_MODULO ??
                                                            0,
                                                    })
                                                    .then(() => {
                                                        props.ListConfigModulo();
                                                        updateConfig();
                                                    });
                                            }}
                                            name="select"
                                        />
                                        <span></span>
                                    </label>
                                </span>
                            </div>
                        </div>
                        <h4>Editar valores fluxo</h4>
                        <div className="d-flex flex-column">
                            <label className="col-12 col-form-label px-0">
                                Permitir a edição dos valores do fluxo de
                                renegociação em Registrar Acordo?
                            </label>
                            <div className="col-12">
                                <span className="switch switch-outline switch-icon switch-success">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={
                                                Config.ConfigCobrancaDTO
                                                    .FL_EDITAR_VALORES_RENEGOCIACAO
                                            }
                                            onChange={() => {
                                                Config.ConfigCobrancaDTO.FL_EDITAR_VALORES_RENEGOCIACAO =
                                                    !Config.ConfigCobrancaDTO
                                                        .FL_EDITAR_VALORES_RENEGOCIACAO;
                                                update();
                                            }}
                                            name="select"
                                        />
                                        <span></span>
                                    </label>
                                </span>
                            </div>
                            <h4>Disparar régua no final de semana</h4>
                            <div className="d-flex flex-column">
                                <label className="col-12 col-form-label px-0">
                                    Permitir o disparo da régua nos finais de semana 
                                </label>
                                <div className="col-12">
                                    <span className="switch switch-outline switch-icon switch-success">
                                        <label>
                                            <input
                                                type="checkbox"
                                                checked={
                                                    Config.ConfigCobrancaDTO
                                                        .FL_COB_DISPARAR_EMAIL_COBRANCA_FIM_DE_SEMANA
                                                }
                                                onChange={() => {
                                                    Config.ConfigCobrancaDTO.FL_COB_DISPARAR_EMAIL_COBRANCA_FIM_DE_SEMANA =
                                                        !Config.ConfigCobrancaDTO
                                                            .FL_COB_DISPARAR_EMAIL_COBRANCA_FIM_DE_SEMANA;
                                                    update();
                                                }}
                                                name="select"
                                            />
                                            <span></span>
                                        </label>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <br />                      
                        <h4>Outros</h4>
                        <form
                            className="form-group row align-items-end"
                            onSubmit={handleSubmit(handleDiasFormSubmit)}
                        >
                            <div className="col-12 col-lg-6">
                                <label>
                                    Limitar dias para Promessa de Pagamento:
                                </label>
                                <input
                                    className={`form-control placeholder-dark-75 ${
                                        formState.errors
                                            .DIAS_PROMESSA_PAGAMENTO &&
                                        "is-invalid"
                                    }`}
                                    type="number"
                                    defaultValue={
                                        config.NR_DIAS_PROMESSA_PAGAMENTO
                                    }
                                    ref={register({
                                        min: {
                                            message:
                                                "Coloque um limite maior ou igual a 0",
                                            value: 0,
                                        },
                                    })}
                                    onChange={handleInputChange}
                                    name="DIAS_PROMESSA_PAGAMENTO"
                                />
                                <div className="invalid-feedback">
                                    {formState.errors.DIAS_PROMESSA_PAGAMENTO
                                        ? formState.errors
                                              .DIAS_PROMESSA_PAGAMENTO.message
                                        : ""}
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <label>
                                    Quantidade mínima de dias corridos para
                                    gerar boletos com parcelas vencidas:
                                </label>
                                <input
                                    className={`form-control placeholder-dark-75 ${
                                        formState.errors
                                            .DIAS_MINIMO_GERAR_BOLETO &&
                                        "is-invalid"
                                    }`}
                                    type="number"
                                    defaultValue={
                                        config.NR_DIAS_MINIMO_GERAR_BOLETO_PARCELA_VENCIDA
                                    }
                                    ref={register({
                                        min: {
                                            message:
                                                "Coloque uma quantidade maior ou igual a 0",
                                            value: 0,
                                        },
                                    })}
                                    onChange={handleInputChange}
                                    name="DIAS_MINIMO_GERAR_BOLETO"
                                />
                                <div className="invalid-feedback">
                                    {formState.errors.DIAS_MINIMO_GERAR_BOLETO
                                        ? formState.errors
                                              .DIAS_MINIMO_GERAR_BOLETO.message
                                        : ""}
                                </div>
                            </div>
                            <div className="d-flex flex-column col-12 col-md-6">
                                <label className="pt-2">
                                    Categoria atendimento{" "}
                                    <span className="font-weight-bolder">
                                        URA
                                    </span>
                                </label>
                                <SelectCategoriaAtendimento
                                    defaultValue={
                                        findCategoria?.ID_CATEGORIA_ATENDIMENTO
                                    }
                                    ID_MODULO={3}
                                    name="ID_CATEGORIA_ATENDIMENTO"
                                    control={control}
                                />
                            </div>
                            <div className="col-12 mt-2">
                                <button
                                    className="btn btn-outline-success font-weight-bold d-none col-12 justify-content-center"
                                    id="cobranca_config_form_submit_button"
                                >
                                    <FontAwesomeIcon
                                        icon={faEdit}
                                        size="lg"
                                        className="mr-1"
                                    />{" "}
                                    Atualizar dados
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </OrSpinner>
        </ConfigGeral.Container>
    );
}

const configMeta: Array<IConfigMeta<IConfigGeral_Cobranca>> = [
    {
        title: "Renegociação",
        configs: [
            {
                config: "FL_COB_PERMITE_REGISTRAR_ACORDO",
                title: "Permitir que sejam registrados acordos de renegociação na tela de atendimento",
                switch: true,
            },
            {
                config: "FL_TELA_RENEGOCIACAO",
                title: "Qual tela de renegociação será utilizada no módulo de cobrança?",
                options: [
                    {
                        value: 0,
                        title: "Integração Completa com UAU",
                        description:
                            "Utilizar a tela de renegociação integrada ao UAU, utilizando o modelo de renegociação cadastrado no UAU",
                    },
                    {
                        value: 1,
                        title: "Sem Integração com UAU",
                        description:
                            " Utilizar a tela de renegociação SEM integração com o UAU. Informando manualmente as parcelas renegociadas.",
                    },
                    {
                        value: 2,
                        title: "Integração Parcial com UAU",
                        description:
                            "Utilizar a tela de renegociação integrada ao UAU, utilizando a tela de geração de boletos sem renegociar o fluxo.",
                    },
                ],
            },
            {
                config: "FL_RENEGOCIACAO_PARCELAS",
                title: "Na tela de renegociação, utilizar:",
                options: [
                    {
                        value: 0,
                        title: "Parcelas vencidas",
                        description: "Exibir apenas as parcelas vencidas.",
                    },
                    {
                        value: 1,
                        title: "Todas Parcelas",
                        description:
                            "Exibir todas as parecelas (vencidas e a vencer).",
                    },
                ],
            },
            {
                config: "FL_RESPEITAR_LIMITE_MODELO",
                title: "Ao registrar acordo, o limite de parcelas deverá:",
                options: [
                    {
                        value: 0,
                        title: "Sem Limite",
                        description:
                            "Ser livre, permitindo que o usuário extrapole a quantidade definida no modelo de renegociação.",
                    },
                    {
                        value: 1,
                        title: "Limitado",
                        description:
                            "Respeitar o limite máximo definido no modelo de renegociação.",
                    },
                ],
            },
            {
                config: "FL_ACORDO_ALTERAR_DATA_VENCIMENTO_FUTURA",
                title: "Ao realizar acordo, permitir alterar a data de vencimento dos boletos futuros?",
                switch: true,
            },
            {
                config: "FL_RENEGOCIACAO_ANALISE",
                title: "Caso estiver desmarcado, acordo seguirá diretamente para o UAU",
                switch: true,
            },
        ],
    },
    {
        title: "Geração de Boleto",
        configs: [
            {
                config: "FL_PARCELAS_BOLETO",
                title: "Na tela de boletos, utilizar:",
                options: [
                    {
                        value: 0,
                        title: "Parcelas vencidas",
                        description: "Exibir apenas as parcelas vencidas.",
                    },
                    {
                        value: 1,
                        title: "Todas Parcelas",
                        description:
                            "Exibir todas as parecelas (vencidas e a vencer).",
                    },
                ],
            },
            {
                config: "FL_ALCADAS_DESCONTO",
                title: "Na tela de boletos, os campos de descontos em juros e multa:",
                options: [
                    {
                        value: 0,
                        title: "Não Utilizar Modelo de Alcadas",
                        description:
                            " Não utilizar o modelo de alcadas de desconto por empreendimento, permitindo remover completamente os juros e multa.",
                    },
                    {
                        value: 1,
                        title: "Utilizar Modelo de Alcadas",
                        description:
                            "Utilizar o modelo de alcadas de desconto por empreendimento. (Necessário configurar este modelo)",
                    },
                ],
            },
            {
                config: "FL_USUARIO_UAU_BOLETO",
                title: "Ao gerar boleto no UAU, será gravado o usuário:",
                options: [
                    {
                        value: 0,
                        title: "Geral da Empresa.",
                        description: undefined,
                    },
                    {
                        value: 1,
                        title: "Configurado no cadastro de Usuário.",
                        description: undefined,
                    },
                ],
            },
            {
                config: "FL_COB_PERMITE_INSERIR_LANCAMENTO_CUSTA",
                title: "Permitir lançamento de custas na tela de atendimento",
                switch: true,
            },
            {
                config: "FL_ACRESCENTAR_RESIDUAL_GERAR_BOLETO",
                title: "Na tela de boletos, mostrar o valor residual das parcelas e permitir seu acréscimo ao valor total?",
                switch: true,
            },
            {
                config: "FL_ANTECIPACAO_PARCELAS_BOLETO",
                title: "Na tela de boletos, permitir o uso do botão de Antecipação de Parcelas para gerar desconto por antecipação?",
                switch: true,
            },
        ],
    },
    {
        title: "Atendimento",
        configs: [
            {
                config: "FL_FILA_COBRANCA",
                title: "Como os atendentes de cobrança irão abrir os atendimentos?",
                options: [
                    {
                        value: 0,
                        title: "Tela de Gestão de Tarefas",
                        description:
                            "Utilizar a tela de gestão das tarefas de cobrança selecionando qual o cliente ele irá trabalhar.",
                    },
                    {
                        value: 1,
                        title: "Tela de Distribuição",
                        description:
                            "Utilizar a tela de distribuição da carteira utilizando a roleta de distribuição dos contratos para a equipe.",
                    },
                ],
            },
            {
                config: "FL_IMPORTAR_PARA_UAU",
                title: "Como será a importação de atendimentos para o UAU?",
                options: [
                    {
                        value: 0,
                        title: "Serviço",
                        description:
                            "Um serviço irá executar, diariamente, a importação dos atendimentos para o UAU",
                    },
                    {
                        value: 1,
                        title: "Direta",
                        description:
                            "A importação para o UAU será feita sincronizada com a execução dos métodos no CRMV2. ( Obs: Isso pode provocar uma queda na velocidade do sistema )",
                    },
                ],
            },
            {
                config: "FL_BLOQUEAR_COBRANCA_QUANDO_PROMESSA",
                title: "Quando uma venda tiver promessa de pagamento, bloquear contato efetivo ou qualquer abertura de atendimento de cobrança?",
                switch: true,
            },
            {
                config: "FL_MOD_ATENDIMENTO_MULT_CASOS",
                title: "Ao entrar em modo de atendimento, permitir atender mais de um caso por vez?",
                switch: true,
            },
            {
                config: "FL_FILA_ABRIR_CASO_PARA_TODAS_VENDAS",
                title: "Ao abrir caso na fila de atendimento, abrir também para as demais vendas do cliente que também estão na fila ?",
                switch: true,
            },
            {
                config: "FL_ALTERAR_STATUS_COBRANCA",
                title: "Ao alterar o status, dentro do atendimento poderá ser editável manualmente o status de uma cobrança",
                switch: true,
            },
        ],
    },
];
